import { getImageBasePath } from 'utils/generics';
import Image from 'next/image';
import { PrimaryButton } from '@acko-tech/building-blocks.ui.button';
import * as Styles from '../styles';

interface IProps {
    text: string;
    subText?: string;
    description: string;
    btnName: string;
    onClick: any;
}

function Failure({ text, subText, description, btnName, onClick }: IProps) {
    return (
        <Styles.Wrapper>
            <Styles.Banner>
                <Image
                    width={'250px'}
                    height={'250px'}
                    alt={''}
                    src={getImageBasePath('/images/errorScreen.svg')}
                />
            </Styles.Banner>
            <Styles.Text>{text}</Styles.Text>
            {subText && <Styles.SubText>{subText}</Styles.SubText>}
            <Styles.Description>{description}</Styles.Description>
            <Styles.GoHomeButtonWrapper>
                <PrimaryButton onClick={onClick}>{btnName}</PrimaryButton>
            </Styles.GoHomeButtonWrapper>
        </Styles.Wrapper>
    );
}

export default Failure;
